if (!customElements.get('nolvya-heriz-controls')) {
  customElements.define('nolvya-heriz-controls', class extends HTMLElement {
    connectedCallback() {
      this.boot = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.started) return;
      this.root = document.getElementById('MainProduct-' + this.dataset.section);
      if (!this.root) return;
      this.started = true;
      this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.format = new Intl.NumberFormat('fr-FR', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {this.frame = 0; this.update();});
      };
      this.onVisibility = () => {if (!document.hidden) this.updateDates();};
      this.onContact = event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || !['#nv-heriz-contact','#nv-heriz-care','#nv-heriz-rooms','#nv-shipping','#nv-returns'].includes(link.getAttribute('href'))) return;
        let target = document.getElementById(link.getAttribute('href').slice(1));
        if(link.getAttribute('href')==='#nv-heriz-rooms')target=document.querySelector('.np-section')||target;
        if (!target) return;
        event.preventDefault();
        if (target.tagName === 'DETAILS') target.open = true;
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
        target.querySelector('h2')?.focus({preventScroll:true});
      };
      this.onSizeToggle = event => {
        const button = event.target.closest('[data-nv-size-toggle]');
        if (!button || !this.root.contains(button)) return;
        const field = button.closest('fieldset');
        if (!field) return;
        field.dataset.nvSizesExpanded = String(field.dataset.nvSizesExpanded !== 'true');
        this.updateSizeChoices();
      };
      this.root.addEventListener('click', this.onSizeToggle);
      this.root.addEventListener('change', this.schedule);
      window.addEventListener('resize',this.schedule,{passive:true});
      this.root.addEventListener('click', this.schedule);
      document.addEventListener('click', this.onContact);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !record.target.closest?.('media-gallery, nolvya-pilot-upgrade') && (record.type === 'childList' || record.target.matches?.('input[name="id"], variant-radios-detail, variant-radios-detail input')))) this.schedule();
      });
      this.observer.observe(this.root, {childList:true, subtree:true, attributes:true, attributeFilter:['value', 'checked']});
      this.timer = setInterval(() => this.updateDates(), 60000);
      this.update();
      this.updateDates();
    }
    getVariant() {
      const fields = [...this.root.querySelectorAll('variant-radios-detail fieldset')];
      const selected = fields.map(field => field.querySelector('input:checked')?.value);
      if (selected.length && selected.every(Boolean)) {
        const match = this.variants.find(v => selected.every((value, i) => (v.options || [v.option1,v.option2,v.option3])[i] === value));
        if (match) return match;
      }
      const id = this.root.querySelector('form[id^="product-form-"] input[name="id"]')?.value || this.dataset.initialVariant;
      return this.variants.find(v => String(v.id) === String(id)) || this.variants[0];
    }
    updateSizeChoices() {
      for (const field of this.root.querySelectorAll('fieldset')) {
        const labels = [...field.querySelectorAll('label[data-nv-size-index]')];
        const button = field.querySelector('[data-nv-size-toggle]');
        if (!labels.length || !button) continue;
        const expanded = field.dataset.nvSizesExpanded === 'true';
        const chosen = labels.find(label => document.getElementById(label.htmlFor)?.checked);
        const entries=labels.map(label=>({label,size:window.NolvyaSizes.parse(document.getElementById(label.htmlFor)?.value)}));
        const valid=entries.filter(entry=>entry.size).map(entry=>({...entry.size,node:entry.label}));
        const showNine=labels.length===9 && window.matchMedia('(min-width:768px)').matches;
        const picks=showNine||labels.length<=8?labels:(valid.length===labels.length?window.NolvyaSizes.spaced(valid,6).map(size=>size.node):labels.slice(0,6));
        const visible = new Set(picks);
        if (chosen && !visible.has(chosen)) {if(visible.size>=6)visible.delete(picks[Math.max(0,picks.length-2)]);visible.add(chosen);}
        button.hidden=visible.size>=labels.length;
        for (const label of labels) label.toggleAttribute('data-nv-size-overflow', !visible.has(label));
        button.setAttribute('aria-expanded', String(expanded));
        const id = field.id || ('nv-sizes-' + this.dataset.section + '-' + labels[0].dataset.nvSizeIndex + '-' + document.getElementById(labels[0].htmlFor)?.name.replace(/[^a-z0-9]/gi, ''));
        field.id = id;
        button.setAttribute('aria-controls', id);
        const text = expanded ? 'Réduire le choix de tailles' : 'Voir toutes les tailles (' + labels.length + ')';
        if (button.textContent !== text) button.textContent = text;
      }
    }
    update() {
      if (!this.root?.isConnected) return;
      this.updateSizeChoices();
      const variant = this.getVariant();
      if (!variant) return;
      this.root.querySelectorAll('[data-nv-buy-now-id]').forEach(node => {if (node.value !== String(variant.id)) node.value = variant.id;});
      this.root.querySelectorAll('[data-nv-buy-now-button]').forEach(node => {node.disabled = !variant.available;});
      this.root.querySelectorAll('[data-nv-divisor]').forEach(node => {
        const value = this.format.format(Math.round(variant.price / Number(node.dataset.nvDivisor)) / 100);
        if (node.textContent !== value) node.textContent = value;
      });
    }
    static holidays(year) {
      const a = year % 19, b = Math.floor(year / 100), c = year % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const date = (h + l - 7 * m + 114) % 31 + 1;
      const easter = Date.UTC(year, month - 1, date, 12);
      const key = value => new Date(value).toISOString().slice(0,10);
      const days = ['01-01','05-01','05-08','07-14','08-15','11-01','11-11','12-25'].map(day => year + '-' + day);
      [1,39,50].forEach(offset => days.push(key(easter + offset * 86400000)));
      return new Set(days);
    }
    static deliveryWindow(now, min, max) {
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(now);
      const get = type => Number(parts.find(p => p.type === type).value);
      const day = Date.UTC(get('year'), get('month') - 1, get('day'), 12);
      const add = count => {
        const date = new Date(day);
        for (let elapsed = 0; elapsed < count;) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !this.holidays(date.getUTCFullYear()).has(date.toISOString().slice(0,10))) elapsed++;
        }
        return date;
      };
      return [add(Math.min(min,max)), add(Math.max(min,max))];
    }
    updateDates(now = new Date()) {
      const dates = this.constructor.deliveryWindow(now, Number(this.dataset.deliveryMin) || 7, Number(this.dataset.deliveryMax) || 10);
      const format = new Intl.DateTimeFormat('fr-FR', {day:'numeric', month:'long', timeZone:'UTC'});
      const node = this.root.querySelector('[data-nv-delivery-window]');
      if (node) {
        const value = 'entre le ' + format.format(dates[0]) + ' et le ' + format.format(dates[1]);
        if (node.textContent !== value) node.textContent = value;
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.boot);
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.root?.removeEventListener('click', this.onSizeToggle);
      this.root?.removeEventListener('change', this.schedule);
      window.removeEventListener('resize',this.schedule);
      this.root?.removeEventListener('click', this.schedule);
      document.removeEventListener('click', this.onContact);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.started = false;
    }
  });
}







